import React from 'react';
import WorkRoute from '../../routes/AsyncWorkRoute';
import ExploreForYouRoute from '../../routes/AsyncExploreForYouRoute';
import ExploreFeedRoute from '../../routes/AsyncExploreFeedRoute';
import ExploreFollowingRoute from '../../routes/AsyncExploreFollowingRoute';
import ErrorPage from '../../routes/ErrorPage';
import Home from '../../routes/AsyncHomeRoute';
import AppLanding from '../../routes/AsyncAppLandingRoute';
import SellYourArtRoute from '../../routes/AsyncSellYourArtRoute';

const EdgeCachableRoute = ({ ttl }) => Component => props => {
  if (props.staticContext) {
    // eslint-disable-next-line no-param-reassign
    props.staticContext.cacheTtl = ttl;
  }

  return <Component {...props} />;
};

export default [
  {
    key: 'app_landing_route',
    path: ['/app', '/:locale/app'],
    component: AppLanding
  },
  {
    key: 'work_route',
    path: ['/explore/works/:workId', '/:locale/explore/works/:workId'],
    component: WorkRoute
  },
  {
    key: 'explore_for_you_route',
    path: ['/explore/for-you', '/:locale/explore/for-you'],
    component: ExploreForYouRoute
  },
  {
    key: 'explore_feed_route',
    path: ['/explore/feed', '/:locale/explore/feed'],
    component: ExploreFeedRoute
  },
  {
    key: 'explore_following_route',
    path: ['/explore/following', '/:locale/explore/following'],
    component: ExploreFollowingRoute
  },
  {
    key: 'explore_sell_your_art_route',
    path: ['/about/selling', '/:locale/about/selling'],
    component: SellYourArtRoute
  },
  {
    key: 'explore_route',
    path: [
      '/explore',
      '/:locale/explore',
      '/explore/home',
      '/:locale/explore/home'
    ],
    component: ExploreForYouRoute
  },
  {
    key: 'home_route',
    path: ['/:locale/boom-home', '/boom-home', '/:locale', '/'],
    component: EdgeCachableRoute({ ttl: 10800 })(Home)
  },
  {
    key: 'error_route',
    component: ErrorPage
  }
];
